import React, { useState, useEffect } from "react";
import Header from "../../components/template/website/Header";
import Footer from "../../components/template/estimate/Footer";
import config from "../../config/config";
import { useHistory } from "react-router-dom";
import navigationsLinks from "../../constants/navigation_links";
import momentTimeZone from "moment-timezone";
import { clearCheckInfoSession } from "../../adapters/session/localSessionAdapter";
export function PaymentSuccess(props) {
  const history = useHistory();

  const formatAddress = (type, address) => {
    return `${address[type + "Address"]}, ${address[type + "Locality"]}, ${
      address[type + "City"]
    }, ${address[type + "State"]}, ${address["pincode"]}`;
  };
  const [data, setData] = useState(null);

  const showMovingOnDate = (date) => {
    const clientTz = momentTimeZone.tz.guess();
    const moveDate = momentTimeZone.utc(date).tz(clientTz);
    return (
      moveDate.format("MMM DD, YYYY ") + "at " + moveDate.format("hh:mm a")
    );
  };
  useEffect(() => {
    const checkoutInfoSession = sessionStorage.getItem("checkoutInfo");
    if (checkoutInfoSession !== undefined) {
      setData(JSON.parse(checkoutInfoSession));
    } else {
      history.push(navigationsLinks.dashboard_page);
    }
  }, [history]);

  const JSX = (
    <>
      <Header />
      <main className="container my-4">
        <div className="text-center">
          <h1>Payment Successfull</h1>
          <div className="img">
            <img
              src={`${config.customerPortal}includes/img/customerDashboard/complete@1x.png`}
              className="img-fluid"
              alt="success"
            />
          </div>
          {data !== null && (
            <>
              <h2 className="my-4">We're eagerly waiting.</h2>
              <div className="row d-flex justify-content-center">
                <div className="col-sm-12 col-md-7">
                  <p className="text-center">
                    Your booking for moving your{" "}
                    <strong> {data["propertySize"]}</strong> from{" "}
                    <strong>
                      {formatAddress("from", data["fromAddress"])}
                    </strong>{" "}
                    to{" "}
                    <strong> {formatAddress("to", data["toAddress"])} </strong>
                    through <strong> {data["vendorName"]} </strong> on
                    <strong> {showMovingOnDate(data["movingOn"])} </strong> has
                    been accepted and your{" "}
                    {data["paymentType"] === "token"
                      ? "token advance"
                      : "payment"}{" "}
                    of <strong>₹ {data["amount"]} /-</strong> has been received.
                  </p>
                </div>
              </div>
            </>
          )}
          <div className="row d-flex justify-content-center">
            <div className="col-12 d-flex justify-content-center mb-5">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  clearCheckInfoSession();
                  history.push(navigationsLinks.dashboard_page);
                }}
              >
                View Dashboard
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
  return JSX;
}
